<template>
  <md-content class="md-scrollbar">
    <div class="send-points-container">
      <div class="choose-recipient-wrapper">
        <h4>Choose recipient</h4>
        <div>
          <SInput
            type="text"
            v-model="query"
            label="Search users"
            otherClasses="mb-0"
            :isSpinner="fetching"
            :plusUser="true"
            @atFocus="isInputFocused = true"
            @atBlur="isInputFocused = false"
            ref="searchInput"
            class="search-member-input"
            dataCy="groupMemberInput"
          />
          <div class="autocomplete-positioning md-scrollbar text-left">
            <SearchUserTransfer
              :query="query"
              :isInputFocused="isInputFocused"
              :returnsTheItem="true"
              :selectedUser="chosenUser"
              @user="setSelectecUser"
              filterType="user"
              dataCy="userSelect"
            />
          </div>
        </div>
      </div>

      <div class="send-points-wrapper">
        <h4>Send points</h4>
        <div id="send points" class="send-points-box">
          <div>
            <p>How many points would you like to send?</p>

            <div class="md-toolbar-section-start">
              <input
                class="input-design"
                :class="[{ 'input-error': !this.isTradePossible }]"
                placeholder="100"
                v-model="quantity"
                pattern="[0-9]*"
                type="number"
                @change="checkPoints()"
                inputmode="numeric"
              />
              <img src="/img/Polygon_7.svg" alt="Swampum" width="25" height="25"/>
            </div>
          </div>
        </div>
        <p class="mb-0">Enter a value that is:</p>
        <div class="requisites-box">
          <md-icon class="icon-margin" v-if="(haveQuantityError === null)">radio_button_unchecked</md-icon>
          <md-icon class="input-correct icon-margin" v-if="(haveQuantityError === false)">check_circle_outline</md-icon>
          <md-icon class="input-error icon-margin" v-if="(haveQuantityError === true)">highlight_off</md-icon>
          <p 
            class="mb-0" 
            :class="[{ 'input-error': haveQuantityError === true, 'input-correct': haveQuantityError === false }]">greater than 0</p>
        </div>
        <div class="requisites-box">
          <md-icon class="icon-margin" v-if="(haveBalanceError === null)">radio_button_unchecked</md-icon>
          <md-icon class="input-correct icon-margin" v-if="(haveBalanceError === false)">check_circle_outline</md-icon>
          <md-icon class="input-error icon-margin" v-if="(haveBalanceError === true)">highlight_off</md-icon>
          <p class="" :class="[{ 'input-error': haveBalanceError === true, 'input-correct': haveBalanceError === false }]">less than your available balance</p>
        </div>
      </div>

      <div class="summary-wrapper">
        <h4>Summary</h4>
        <div id="summary" class="send-points-box summary-box">
          <div class="summary-transfering-to">
            <div>
              <p>Points you are transferring to <router-link class="balance-color" :to="`/s-app/profile-page/${this.chosenUser.id}`">{{ this.chosenUser.username }}</router-link>:</p> <span>{{ formatPoints(this.quantity) }}</span>
            </div>
          </div>
          <div class="summary-balance-after-transfer">
            <div>
              <p>Your balance after this transfer:</p> <span>{{ formatPoints(myPointsSum - this.quantity)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div id="button" class="btn-position">
        <SButtonMaterial
          buttonType="button"
          class="btn-size"
          color="primary"
          textColor="white"
          materialClass="dense"
          @button="sendPoints"
          text="Send"
          :disabled="!isTradePossible"
          iconLeftText="send"
          iconColor="white"
          :data-cy="`${dataCy}-btn`"
        />
      </div>
    </div>
    <Modal
      id="modal"
      buttonName="OK"
      ref="modal"
      title="Send Points"
      data-cy="modalPointsSent"
      :material-button="true"
      @button="closeResponseModal"
    >
      <footer class="h5" data-cy="sendResponse">
        Points sent successfully!
      </footer>
    </Modal>
    <Modal
      id="confirmation-modal"
      ref="confirmation-modal"
      title="Confirm action"
      data-cy="confirmSendPoints"
      :material-button="true"
    >
      <footer class="h5" data-cy="sendResponse">
        <p>
          You are about to send {{ this.quantity }} points to @{{ this.chosenUser.username }}.
        </p>
        <p>
          Are you sure you want to do this?
        </p> 
      </footer>
      <div class="btns-area">
        <SButtonMaterial
          buttonType="button"
          class="mb-1 btn-modal bt-1"
          color="white"
          textColor="danger"
          borderColor="white"
          materialClass="dense"
          text="NO, GO BACK"
          @button="closeConfirmationModal"
          data-cy="confirmSendPoints-btn"
        />
        <SButtonMaterial
          buttonType="button"
          class="mb-1 btn-modal bt-1"
          color="primary"
          textColor="white"
          borderColor="primary"
          materialClass="dense"
          text="YES, CONTINUE"
          @button="buttonSend"
          data-cy="denySendPoints-btn"
        />
      </div>
      <p>This action cannot be undone</p>
    </Modal>
  </md-content>

</template>

<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
import PointsHelperVue from "@/mixins/PointsHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import SInput from "@/components/atoms/SInput";
import SearchUserTransfer from "@/components/molecules/SearchUserTransfer.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import Auth from '../../modules/Auth';
import Global from '../../constants/Global';
import axios from 'axios';
import Modal from "@/components/atoms/Modal";

const headers = {
  'auth_key': Auth.getToken(),
  'Content-Type': 'application/json'
};

export default {
  name: "PointsSend",
  mixins: [UserHelperVue, PointsHelperVue, ItemHelperVue],
  props: ["history"],
  components: {
    SInput,
    SearchUserTransfer,
    SButtonMaterial,
    Modal,
  },
  data() {
    return {
      chosenUser: [],
      fetching: false,
      timeStampFromLastChar: null,
      query: "",
      isInputFocused: false,
      quantity: null,
      hasQuantityError: null,
      hasBalanceError: null,
    };
  },
  computed: {
    isTradePossible() {
      let trade = true;
      if (this.chosenUser.length === 0)
          trade = false;
      if (this.hasQuantityError||this.hasBalanceError)
        trade = false;
      return trade;
    },
    haveQuantityError() {
      if (!this.quantity || this.quantity === "")
      return null
      else if (this.quantity <= 0) 
        return true
      else 
        return false;
    },
    haveBalanceError() {
      if (!this.quantity || this.quantity === "")
      return null
      else if (this.quantity > this.myPointsSum) 
        return true;
      else
        return false;
    },
  },
  methods: {
    setSelectecUser(n) {
      this.chosenUser = n;
      this.query = n.username;
      localStorage.setItem("sendPointsUser", JSON.stringify(this.chosenUser));
    },
    saveValueInformation() {
      this.hasQuantityError = false;
      this.hasBalanceError = false;
      localStorage.setItem("sendPointsValue", this.quantity);
    },
    checkPoints() {
      if (this.quantity <= 0) 
        this.hasQuantityError = true;
      else 
        this.hasQuantityError = false;
      
      if (this.quantity > this.myPointsSum) 
        this.hasBalanceError = true;
      else
        this.hasBalanceError = false;
    },
    sendPoints() {
      if (!this.hasBalanceError && !this.hasQuantityError)
        $("#confirmation-modal").modal("show");
    },
    async buttonSend() {
      let transaction = this.chosenUser;
      transaction.quantity = this.quantity;
      transaction.note = `points send directly to user ${this.chosenUser.username}`
      await axios.post(Global.getServerDomain() + '/profile/points/send', transaction, { headers })
      this.closeConfirmationModal();
      $("#modal").modal("show");
    },
    closeConfirmationModal() {
      $("#confirmation-modal").modal("hide");
    },
    closeResponseModal() {
      $("#modal").modal("hide");
      localStorage.removeItem('sendPointsValue');
      localStorage.removeItem('sendPointsUser');
      localStorage.setItem("pointsSection", "history");
      location.reload();
    },
    formatPoints(swampumPoints) {
      return Number(swampumPoints).toLocaleString('en-US')
    }
  },
  created() {
    if(localStorage.getItem('sendPointsValue'))
      this.quantity = localStorage.getItem('sendPointsValue');
    if(JSON.parse(localStorage.getItem('sendPointsUser')))
      this.chosenUser = JSON.parse(localStorage.getItem('sendPointsUser'));
  },
};
</script>

<style lang="scss" scoped>
.send-points-container {
  width: 70%;
  margin: auto;
}
.send-points-container h4, p {
  font-weight: bolder;
  color: gray;
}
.recent-users {
  display: flex;
  flex-direction: row;
  min-height: 90px;
  align-items: center;
}
.recent-users-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
}
.summary-wrapper {
  margin-top: 10px;
}
.input-design {
  border: 0px;
  border-bottom: 3px solid #979797;
  max-width: 40%;
  font-size: 2rem;
  color: $primary;
  padding: 0;
  text-align: right;
  margin-right: 10px;
}
.input-error {
  color: red !important;
}
.input-correct {
  color: $primary !important
}
.icon-margin {
  margin: 0 5px 0 0;
}
.requisites-box {
  display: flex;
}
.send-points-box {
  background-color: lightgray;
  border-radius: 12px;
  padding: 15px;
}
.summary-box {
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 15px;
}
.balance-color {
  color: $primary;
}

.summary-balance-after-transfer {
  width: 100%;

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      color: $primary;
      margin: 0;
    }

    span {
      color: $primary;
      font-weight: bold;
    }
  }
}
.summary-transfering-to{
  width: 100%;

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      margin: 0;
    }

    span {
      color: $dark;
      font-weight: bold;
    }
  }
}
.btn-position {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.btn-size {
  width: 75%;
  height: 36px;
  border-radius: 12px;
}
.btns-area {
  display: flex;
  width: 100%;
}
.btn-modal {
  width: 50%;
  margin: 0 5px;
  min-width: none;
  border-radius: 12px;
}
@media screen and (max-width: 460px) {
  .input-design {
    max-width: 100%;
  }
}
</style>
<style>
#button span {
  margin-left: 10px;
}
</style>

